import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./biltyReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable.js";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useRef, useState, useEffect } from "react";
let ex_data = [];

function LrMasterReport({ sessionObject }) {
    const branchId = sessionObject.sessionVariables.branch_id;

    const columns = React.useMemo(
        () => [
            {
                Header: "Station Name",
                accessor: "branch_name",
                width: "200px",
                minWidth: "200px",
                canFilter: true,
            },
            {
                Header: "Start No",
                accessor: "start_no",
                width: "200px",
                minWidth: "200px",
                canFilter: true,
            },
            {
                Header: "End No",
                accessor: "end_no",
                width: "200px",
                minWidth: "200px",
                canFilter: true,
            },
            {
                Header: "Created Date",
                accessor: "created_date",
                width: "200px",
                minWidth: "200px",
                canFilter: true,
            },
        ],
        []
    );

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const fetchIdRef = React.useRef(0);
    const download_ref = React.useRef(null);
    const sortIdRef = React.useRef(0);
    const [dateState, setDateState] = React.useState({
        date_from: new Date(),
        date_to: new Date(),
    });
    const [finalInput, setFinalInput] = React.useState({});

    const fetchData = React.useCallback(
        async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
            const fetchId = ++fetchIdRef.current;
            
            setLoading(true);

            if (fetchId === fetchIdRef.current) {
                let newObject = {}
                newObject = { ...newObject, ...customFilters }
                delete newObject.companyId
                delete newObject.fyear

                let inputData = {
                    paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
                    sort_fields: sortBy,
                    filter_fields: newObject,
                    date_dict: {
                        date_from: dateObject.date_from,
                        date_to: dateObject.date_to,
                    },
                };

                setFinalInput(inputData);

                let response = await fetch(SERVER_URL + "/report/assign_bilty_no_report/", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(inputData),
                });
                let resp = await response.json();


                if (resp["data"] && "total_rows" in resp) {
                    setData(resp["data"]);
                    setPageCount(Math.ceil(resp["total_rows"] / pageSize));
                }
                setLoading(false);
            }
        },
        []
    );

    return (
        <div className="page-marfatiya-wise">
            <div className="report-bilty">
                <div className="form-header">LR Master Report</div>
                <div className="report-bilty-table-container">
                    <div className="report-field-row ">
                        <div>
                            From Date:{" "}
                            <DatePicker
                                dateFormat="dd-MM-yyy"
                                selected={dateState.date_from}
                                onChange={(date) =>
                                    setDateState({
                                        ...dateState,
                                        ["date_from"]: date,
                                    })
                                }
                            />
                        </div>
                        <div>
                            To Date:{" "}
                            <DatePicker
                                dateFormat="dd-MM-yyy"
                                selected={dateState.date_to}
                                onChange={(date) =>
                                    setDateState({
                                        ...dateState,
                                        ["date_to"]: date,
                                    })
                                }
                            />
                        </div>
                    </div>
                    <ReportTable
                        columns={columns}
                        data={data}
                        fetchData={fetchData}
                        dateObject={dateState}
                        loading={loading}
                        pageCount={pageCount}
                    />
                </div>
            </div>
        </div>
    );
}

export default LrMasterReport;
